import React from 'react';
import DatePicker from 'react-multi-date-picker';
import Select from 'react-select';
import Alert from '../components/features/Alert';
import Dropdown from '../components/features/Notifications.jsx';
import Modal from '../components/features/Modal';
import Table from '../components/features/Table';
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import {LoadingToast, Toastify} from '../components/utils';
import { useSelector } from 'react-redux';
import Phone from '../components/features/Phone.jsx';
import Email from '../components/features/Email.jsx';
import Charts from '../components/features/Charts.jsx';
import FieldContainer from '../components/features/FieldContainer';
import Attachments from '../components/features/Attachments';
import MyEditor from '../components/features/MyEditor.jsx';
import UploadVideo from '../components/features/UploadVideo';

const Features = () =>
{
	const preferences = useSelector((state) => state.preferences);
	const settings = useSelector((state) => state.settings);
	const head = [ 'ID', 'نام', 'سال' ];
	const content = [["10001","ماهان",'2002'],["10002","Mahan",'2003'], ["10003","Milad",'2004' ],];
	const actions = [{"edit": "LINK", "delete": "LINK"}, {"edit": "LINK", "delete": "LINK"}, {"edit": "LINK", "delete": "LINK"},];
	const DropdownData = [
		[{label: 'ماهان', link: '#1'}, {label: 'میلاد', link: 'https://www.google.com'}, {label: 'Max', link: '#3'}],
		[{label: 'محسن'}, {label: 'مریم', link: 'https://www.google.com'}, {label: 'امیر', link: '#3'}],
	];
	const options = [
		{ value: 'chocolate', label: 'شکلات' },
		{ value: 'strawberry', label: 'توت فرنگی' },
		{ value: 'vanilla', label: 'وانیل' }
	];
	const attachmentTypes = {
		'card': 'کارت ملی',
		'certificate': 'شناسنامه'
	};
	// const attachmentDefault = [
	// 	{
	// 		'id': '123',
	// 		'type': 'کارت ملی',
	// 		'name': '2012-20-20-ImagePic.v2.card.png',
	// 		'url': 'http://localhost:3000/images/profile.jpg',
	// 	},
	// 	{
	// 		'id': '456',
	// 		'type': 'شناسنامه',
	// 		'name': 'Certificate.jpeg',
	// 		'url': 'http://localhost:3000/images/profile.jpg',
	// 	},
	// 	{
	// 		'id': '',
	// 		'type': 'کارت ملی',
	// 		'name': '2012-20-20-ImagePic.v2.card.png',
	// 		'url': '',
	// 	}];

	// const GetEditorValue = (text) =>
	// {
	// };

	return(
		<React.Fragment>
			<div className='wrapper'>
				<div className='title'>
					<h6>ادیتور متن پیشرفته</h6>
				</div>
				<MyEditor initialContent='' onSubmit='' onCommentChange='' />
			</div>
			<div className='wrapper'>
				<div className='title'>
					<h6>دکمه</h6>
				</div>
				<h6>Button CSS</h6>
				<button className='btn-primary'>اصلی</button>
				<button className='btn-primary secondary'>فرعی</button>
			</div>
			<div className='wrapper'>
				<div className='title'>
					<h6>پاپ آپ</h6>
				</div>
				<h6>Component</h6>
				<Modal title='اطلاعات بیشتر' content='محتوای پاپ آپ'/>
			</div>
			<div className='wrapper'>
				<div className='title'>
					<h6>دراپ دان</h6>
				</div>
				<h6>Component</h6>
				<Dropdown data={DropdownData} label='وضعیت خدمت' />
			</div>
			<div className='wrapper'>
				<div className='title'>
					<h6>نوتیفیکشن</h6>
				</div>
				<h6>Component</h6>
				<button className='btn-primary' onClick={() => {Toastify('این یک پیام است.')}}>نمایش نوتیفیکشن</button>
				<button className='btn-primary' onClick={LoadingToast}>نمایش لودینگ</button>
			</div>
			<div className='wrapper'>
				<div className='title'>
					<h6>پیام</h6>
				</div>
				<h6>Component</h6>
				<Alert title='خطا!' message='این یک اخطار است!' color="danger"></Alert>
				<Alert title='هشدار!' message='این یک هشدار است!' color="warning"></Alert>
				<Alert title='تایید!' message='این یک تایید است!' color="success"></Alert>
				<Alert title='پیام!' message='این یک پیام است!'></Alert>
			</div>
			<div className='wrapper'>
				<div className='title'>
					<h6>جدول</h6>
				</div>
				<h6>CSS</h6>
				<Table header={head} content={content} actions={actions} itemsPerPage ={2}/>
				<br/><br/>
			</div>
			<div className='wrapper flex flex-wrap'>
				<div className='title'>
					<h6>فرم</h6>
				</div>
				<FieldContainer label='فیلد متنی'>
					<input type="text"></input>
				</FieldContainer>
				<FieldContainer label='فیلد متنی غیرفعال'>
					<input type="text" disabled></input>
				</FieldContainer>
				<Phone />
				<Email />
				<FieldContainer label='انتخاب'>
					<Select
						options={options}
						isClearable={false}
						menuPlacement="auto"
						className={settings.strings.dropdown_container}
						classNamePrefix={settings.strings.dropdown_prefix}
					/>
				</FieldContainer>
				<FieldContainer label='چند انتخابی'>
					<Select
						isMulti
						options={options}
						isClearable={false}
						menuPlacement="auto"
						className={settings.strings.dropdown_container}
						classNamePrefix={settings.strings.dropdown_prefix}
					/>
				</FieldContainer>
				<FieldContainer label='چک باکس'>
					<input type="checkbox"/>
					<input type="checkbox" disabled/>
					<input type="checkbox" readOnly/>
				</FieldContainer>
				<FieldContainer label='سوییچ'>
					<input className="form-check-input switch" type="checkbox"/>
					<input className="form-check-input switch" type="checkbox" disabled/>
					<input className="form-check-input switch" type="checkbox" disabled checked/>
				</FieldContainer>
				<FieldContainer label='رادیو'>
					<div><input type="radio"/><label className="inline-block">مرد</label></div>
					<div><input type="radio"/><label className="inline-block">زن</label></div>
					<div><input type="radio" disabled/><label className="inline-block">غیرفعال</label></div>
					<div><input type="radio" readOnly/><label className="inline-block">غیرفعال</label></div>
				</FieldContainer>
				<FieldContainer label='تاریخ تولد'>
					<DatePicker
						calendar={preferences.language === 'en_US' ? null : persian}
						locale={preferences.language === 'en_US' ? null : persian_fa}
						inputClass="date-picker"
						containerClassName="w-full"
						arrow={false}
						calendarPosition="bottom-right"
						hideOnScroll
					/>
				</FieldContainer>
				<FieldContainer label='متن'>
					<textarea></textarea>
				</FieldContainer><FieldContainer>
				</FieldContainer>
				<FieldContainer label='چند فایل'>
					<Attachments types={attachmentTypes} defaultValue={[]}/>
				</FieldContainer>
				<FieldContainer label='تک فایل'>
					<Attachments single={true}/>
				</FieldContainer>
				<FieldContainer label='آپلود به ابرآمد'>
					<UploadVideo />
				</FieldContainer>
			</div>
			<div className='wrapper'>
				<div className='title'>
					<h6>چارت</h6>
				</div>
				{/* <Charts labels={['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange']} data={[12, 19, 3, 5, 2, 3]} /> */}
			</div>
		</React.Fragment>
	);
}

export default Features;